<template>
  <section id="related-colors">
    <h2>{{ $t('Other models available') }}</h2>
    <ul>
      <li v-for="item in items">
        <RelatedColorsItem :item="item"/>
      </li>             
    </ul>
  </section>
</template>

<script>
import RelatedColorsItem from './RelatedColorsItem.vue';

export default {
  name: 'related-colors',
  props: ['items'],
  components: {
    RelatedColorsItem
  }
}
</script>

<style lang="scss" scoped>
  @import '~theme/css/core';

  #related-colors {
    background-color: transparent;

    h2 {
      font-size: 1.5rem;
      margin-bottom: 2.5rem;
      margin-top: 4rem;
      text-align: left;

      @include bp(max lg) {
        margin-top: 2rem;
      }
    }

    ul {
      padding-left: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      li {
        list-style-type: none;
      }
    }
  }
  
</style>